import { Box } from "@chakra-ui/react";

export function Footer() {
  return <Box></Box>;
}
